// extracted by mini-css-extract-plugin
export default {"noDataContainer":"styles_noDataContainer__34Ih2"};